import {useContext} from "react";
import {CustomThemeContext, Theme} from "../components/CustomThemeProvider/CustomThemeProvider";

export const useTheme = (): {
    theme: Theme;
    setTheme: (theme: Theme) => void;
} => {
    return useContext(CustomThemeContext);
};
